module.exports = __webpack_public_path__ + "img/chips.04e10720.svg";